export const GRAPH_FILL_COLOR = [
  "#3256BB",
  "#637EC8",
  "#95A7D8",
  "#C6CFE8",
  "#E5E9F2",
];
